<template>
  <base-layout>
    <template v-slot:header>
      <app-header />
    </template>
    <template v-slot:banner>
     <Banner :title="title" />
    </template>
    <template v-slot:default>
      <section>
        <div class="container" role="tablist" style="margin-bottom: 20px">
          <b-card no-body class="mb-1" v-for="faq in faqs" :key="faq.id">
            <b-card-header header-tag="span" class="card-header p-0z-depth-1">
              <b-link v-b-toggle="'accordion-' + faq.id">
                <h4 class="text-uppercase white-text mb-0 py-3 mt-1 h4">
                  {{faq.title}}
                  <b-icon-chevron-down></b-icon-chevron-down>
                </h4>
              </b-link>
            </b-card-header>
            <b-collapse :id="'accordion-' + faq.id" role="tabpanel">
              <b-card-body class="card-body rgba-black-light white-text z-depth-1">
                <p class="lead p-md-4 mb-0">{{faq.text}}</p>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </section>
    </template>

    <template v-slot:footer>
      <app-footer />
    </template>
  </base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import faqs from '../config/faqs.json'
import BaseLayout from '@/layout/BaseLayout'

export default {
  title: 'Frequently Asked Questions',
  components: {
    BaseLayout,
    AppHeader,
    AppFooter
  },
  data () {
    return {
      faqs
    }
  }
}
</script>
<style scoped>
.card {
    -moz-box-direction: normal;
    -moz-box-orient: vertical;
    background-color: #fff;
    border-radius: 0.25rem;
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom:1px;
    border:none;
}
.card-header:first-child {
    border-radius: 0;
}
.card-header {
    background-color: #f7f7f9;
    margin-bottom: 0;
    padding: 20px 1.25rem;
    border:none;
}

.card-header p{
    margin:0;
}
</style>



// WEBPACK FOOTER //
// src/pages/FAQs.vue